// Вкладки: одинаковое управление мышью и клавиатурой (стрелки, Home, End).
import { useRef, useState, type KeyboardEvent } from "react";

export function useTabs<T extends string>(ids: readonly T[], initial: T) {
  const [selected, setSelected] = useState<T>(initial);
  const refs = useRef(new Map<T, HTMLButtonElement>());
  const onKeyDown = (id: T) => (event: KeyboardEvent) => {
    const index = ids.indexOf(id);
    const next = event.key === "ArrowRight" ? (index + 1) % ids.length
      : event.key === "ArrowLeft" ? (index + ids.length - 1) % ids.length
      : event.key === "Home" ? 0 : event.key === "End" ? ids.length - 1 : null;
    if (next === null) return;
    event.preventDefault();
    setSelected(ids[next]);
    refs.current.get(ids[next])?.focus();
  };
  const tab = (id: T) => ({
    role: "tab" as const,
    type: "button" as const,
    "aria-selected": selected === id,
    tabIndex: selected === id ? 0 : -1,
    onClick: () => setSelected(id),
    onKeyDown: onKeyDown(id),
    ref: (node: HTMLButtonElement | null) => { if (node) refs.current.set(id, node); else refs.current.delete(id); },
  });
  return { selected, tab };
}
